/* eslint-disable no-useless-escape */
import * as Yup from 'yup';
import {
	// containsOnlyDigits,
	// containsOnlyDigitsOrLetters,
	containsOnlyLetters,
	// hasTwoWords,
	isString,
	// isStringOrNumber,
	// hasStringLengthOf,
	hasStringLengthMinMax,
	// removeNonAlphabetOrDigits,
	// removeNonDigits,
	// removeNonCharsKeepSpace,
	// limitLength,
	localPart,
	domainPart,
	// doesNotEndWithWeb,
	doesNotContainNonLatinCodepoints,
	beginsWithHyphen,
	endsWithHyphen
} from './string-num-clean.js';

export function regularFilter(str) {
	// http://emailregex.com/

	const email = new RegExp(
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	);

	return email.test(str);
}

/* see validate-email.test.js for selected rules */
async function isEmail(t) {
	if (!isString(t)) return false;
	const emailSchema = Yup.string()
		.strict(true)
		.required()
		.email()

		// eslint-disable-next-line no-template-curly-in-string
		.test('is-email', '${path} is a valid email', val => {
			const localParts = localPart(val);
			const domainParts = domainPart(val);
			const domainLabels = domainParts.split('.');
			const topDomain = domainLabels[domainLabels.length - 1];
			let allDomainLabelsWithinLength = true;
			let allDomainLabelsWithoutHyphons = true;
			domainLabels.forEach(label => {
				if (hasStringLengthMinMax(label, 1, 63)) return;
				allDomainLabelsWithinLength = false;
			});
			domainLabels.forEach(label => {
				allDomainLabelsWithoutHyphons =
					beginsWithHyphen(label) || endsWithHyphen(label) || label.includes('--')
						? false
						: allDomainLabelsWithoutHyphons;
			});
			return (
				doesNotContainNonLatinCodepoints(val) &&
				!(topDomain.includes('web') || topDomain.includes('WEB')) &&
				hasStringLengthMinMax(localParts, 1, 63) &&
				allDomainLabelsWithinLength &&
				allDomainLabelsWithoutHyphons &&
				containsOnlyLetters(topDomain) &&
				regularFilter(val) &&
				hasStringLengthMinMax(val, 6, 255)
			);
		});
	return emailSchema.isValid(t);
}
export default isEmail;
